/**
 * Thingviewer Gutenberg block
 */

const { registerBlockType } = wp.blocks;
const { 
    RawHTML,
    userState 
} = wp.element;
const { 
    InspectorControls,
    MediaUpload
} = wp.editor;
const { 
    PanelBody,
    Button,
    RangeControl,
    ToggleControl
} = wp.components;

registerBlockType( 'wp3d-thingviewer-lite/gutemberg-block', {
    title: 'WP 3D Thingviewer Lite',
    icon: 'embed-generic',
    description: 'Embed a WP 3D Thingviewer into the content',
    category: 'embed',
    example: {},
    attributes: {
        model_url : {
            type     : 'string',
            default  : ''
        },
        model_url_bck : {
            type     : 'string',
            default  : ''
        },
        model_id : {
            type    : 'number',
            default : ''
        },
        model_id_bck : {
            type    : 'number',
            default : ''
        },
        model_preview : {
            type     : 'string',
            default  : ''
        },
        rotation_x : {
            type    : 'number',
            default : 0
        },
        rotation_y : {
            type    : 'number',
            default : 0
        },
        rotation_z : {
            type    : 'number',
            default : 0
        },
        link_cloaking : {
            type   : 'boolean',
            default: false
        }
    },
    edit: ({ attributes, setAttributes }) => {
        const {
            model_url,
            model_url_bck,
            model_id,
            model_id_bck,
            model_preview,
            rotation_x,
            rotation_y,
            rotation_z,
            link_cloaking,
        } = attributes;
        const ALLOWED_MEDIA_TYPES = ['application/sla', 'application/octet-stream', 'application/octet-stream', 'text/plain'];

        var shortcode = [
            '[wp-3dtvl model_id="' + attributes.model_id + '"',
            'model_file="' + attributes.model_url + '"',
            'model_preview="' + attributes.model_preview + '"',
            'rotation_x="' + attributes.rotation_x + '"',
            'rotation_y="' + attributes.rotation_y + '"',
            'rotation_z="' + attributes.rotation_z + '"][/wp-3dtvl]'
        ].join(' ');    

        function onRotationXChange(new_value) {
            setAttributes({ rotation_x: new_value });
        }
        function onRotationYChange(new_value) {
            setAttributes({ rotation_y: new_value });
        }
        function onRotationZChange(new_value) {
            setAttributes({ rotation_z: new_value });
        }
        function onSelectModel(new_media) {
            if ( new_media && new_media.url && new_media.id) {
                setAttributes({ model_id_bck: new_media.id })
                setAttributes({ model_url_bck: new_media.url })

                if ({link_cloaking} == true) {
                    setAttributes({ model_id: new_media.id })
                    setAttributes({ model_url: '' })
                } else {
                    setAttributes({ model_id: '' })
                    setAttributes({ model_url: new_media.url })
                }
            }
        }
        function onSelectPreview(new_media) {
            if ( new_media && new_media.sizes ) {
                setAttributes({ model_preview: new_media.sizes.full.url })
            }
        }
        function onLinkCloakingSwitch(new_value) {
            setAttributes({ link_cloaking: new_value })
            if (new_value == true) {
                if ( {model_id_bck} != '') {
                    setAttributes({ model_id: model_id_bck })
                    setAttributes({ model_url: '' })
                }
            } else {
                if ( {model_url_bck} != '') {
                    setAttributes({ model_id: '' })
                    setAttributes({ model_url: model_url_bck })
                }
            }
        }

        return ([
            <InspectorControls style={{ marginBottom: '40px' }}>
                <PanelBody title={ "Model File" }>
                    <input type="text" value={model_url_bck} style={{ marginBottom: '10px' }} />
                    <MediaUpload
                        style={{ marginBottom: '20px', marginTop: '10px' }}
                        onSelect={ onSelectModel }
                        allowedTypes={ ALLOWED_MEDIA_TYPES }
                        value={ model_url_bck }
                        render={ ( { open } ) => (
                            <Button 
                                onClick={ open }
                                variant="primary"
                                >Select 3D Model</Button>
                        ) }
                    />,
                    <ToggleControl 
                        style={{ marginBottom: '10px', marginTop: '10px' }}
                        label={ "Link Cloaking" }
                        help={
                            link_cloaking
                                ? "The model file url is invisible and will be loaded using the Wordpress REST Api."
                                : "The model file url is visible."
                        }
                        checked={ link_cloaking }
                        onChange={ onLinkCloakingSwitch }
                    />
                </PanelBody>
                <PanelBody title={ 'Preview Image' }>
                    <input type="text" value={model_preview} style={{ marginBottom: '10px' }} />
                    <MediaUpload
                        style={{ marginBottom: '10px', marginTop: '10px' }}
                        onSelect={ onSelectPreview }
                        allowedTypes={ ['image'] }
                        value={ model_preview }
                        render={ ( { open } ) => (
                            <Button 
                                onClick={ open }
                                variant="primary"
                                >Select Preview Image</Button>
                        ) }
                    />
                </PanelBody>
                <PanelBody title={ "Model Settings" }>
                    <RangeControl 
                        label={ "Rotation X" } 
                        value={ rotation_x }
                        onChange={ onRotationXChange } 
                        min={ 0 }
                        max={ 360 }
                        step={ 1 }
                    />
                    <RangeControl 
                        label={ "Rotation Y" } 
                        value={ rotation_y }
                        onChange={ onRotationYChange } 
                        min={ 0 }
                        max={ 360 }
                        step={ 1 }
                    />
                    <RangeControl 
                        label={ "Rotation Z" } 
                        value={ rotation_z }
                        onChange={ onRotationZChange } 
                        min={ 0 }
                        max={ 360 }
                        step={ 1 }
                    />
                </PanelBody>
            </InspectorControls>,
            <RawHTML>{shortcode}</RawHTML>
        ]);
    },
    save: ({ attributes }) => {       
        var shortcode = [
            '[wp-3dtvl model_id="' + attributes.model_id + '"',
            'model_file="' + attributes.model_url + '"',
            'model_preview="' + attributes.model_preview + '"',
            'rotation_x="' + attributes.rotation_x + '"',
            'rotation_y="' + attributes.rotation_y + '"',
            'rotation_z="' + attributes.rotation_z + '"][/wp-3dtvl]'
        ].join(' ');

        return (<RawHTML>{shortcode}</RawHTML>);
    },
});